module.exports = __webpack_public_path__ + "img/close-x.99d14b38.svg";